import { styled, Typography } from '@mui/material'

export const Title = styled(Typography)(() => ({
  fontWeight: 'bold',
  margin: '15px 0',
}))

export const ManualImage = styled('img')(() => ({
  width: '100%',
  maxWidth: 600,
  maxHeight: 200,
  objectFit: 'contain',
}))

export const ManualVideo = styled('iframe')(() => ({
  width: '100%',
  height: 300,
  maxWidth: 600,
  maxHeight: 300,
  marginBottom: 100,
}))
